import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useAuth from '../../../hooks/useAuth'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Card as MuiCard, CardContent, Divider, LinearProgress, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { spacing } from '@mui/system'
import IssuesGrid from '../../../components/entities/IssuesGrid'
import IssueApi from '../../../api/IssueApi'
import { EnrichedIssueEntity } from 'types/IssueEntity'

const Card = styled(MuiCard)(spacing)

function AdminIssuesTable({ issues }: { issues: Array<EnrichedIssueEntity> }) {
    return (
        <IssuesGrid
            availableColumns={['issueType', 'shareName', 'tags', 'status', 'subEndDate', 'updatedAt']}
            issues={issues}
            pagination={true}
            pageSizeInitialState={100}
            pageSizeOptions={[10, 25, 100]}
            filters={true}
            detailsPath={(issue) => `/admin/issues/${issue.id}`}
            sortModel={[
                { field: 'status', sort: 'asc' },
                { field: 'updatedAt', sort: 'desc' },
            ]}
        />
    )
}

const issueApi = new IssueApi()

function AdminIssuesView() {
    const { t } = useTranslation()
    const [issues, setIssues] = useState<Array<EnrichedIssueEntity> | null>(null)
    const { isAuthenticated } = useAuth()

    useEffect(() => {
        async function fetchData() {
            if (!isAuthenticated) return
            const fetchedIssues = await issueApi.findAll()
            setIssues(fetchedIssues)
        }
        fetchData()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title={t('entities.issue.plural')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {t('entities.issue.plural')}
            </Typography>
            <Divider />
            <Card mb={6}>
                <CardContent>
                    {!issues && <LinearProgress />}
                    {issues && <AdminIssuesTable issues={issues} />}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default AdminIssuesView
